import { generateLabelsAndValues } from "../utils/helperFunctions";

export const TypeOfCPD = {
  FORMAL_EDUCATION: 1,
  INFORMAL_EDUCATION: 2,
  CONGRESS_CONFERENCE_SEMINAR_SYMPOSIUM: 3,
  FELLOWSHIPS_ATTACHMENT_STUDY_TOUR: 4,
  COMMITTEE_PROJECT_MEMBER: 5,
  TECHNOLOGY_AND_TECHNICAL_RELATED_MEETING: 6,
  TECHNICAL_PAPER_PRESENTATION_AT_OFFICAL_FUNCTION_SEMINAR_MEETINGS: 7,
  PUBLICATION_OF_ARTICLES_IN_JOURNAL_CHAPTERS_IN_BOOK_TECHNICAL_REPORTS: 8,
  APPOINTED_AS_MBOT: 9,
  PROFESSIONAL_ASSESSOR_PANEL: 10,
  ACCREDITATION_ASSESSOR_PANEL: 11,
  ACCREDITATION_VISITS: 12,
  CONTRIBUTION_FOR_TECHNOLOGY_AND_TECHNICAL_ASPECTS_DEVELOPMENT: 13,
  ONLINE_PLATFORM_RELATED_TO_TECHNOLOGY_AND_TECHNICAL: 14,
  MENTORING_COACHING_JUDGES_CONSULTATION_RELATED_TO_PROFESSION: 15,
  HANDS_ON_SPECIAL_PROJECT_AND_RND_ACTIVITIES_RELATED_IN_TECHNOLOGY_AND_TECHNICAL: 16,
  CSR_PROGRAMME_AND_RELEVENT_VOLUNTARY_WORK: 17,
  SOFT_SKILLS_RELATED_TO_LEADERSHIP_AND_MANAGEMENT_INTERPERSONAL_SKILLS_AND_PROFESSIONAL_CONDUCT: 18,
};

export const UserCPDStatus = {
  PENDING: 1,
  SUBMITTED: 2,
  APPROVED: 3,
  REJECTED: 4,
  KIV: 5,
  INCOMPLETE_DOCUMENT: 7,
};
export const TypeOfCPDActivities = generateLabelsAndValues(TypeOfCPD);
export const TypeOfUserCPDStatus = generateLabelsAndValues(UserCPDStatus);
